module.exports = __webpack_public_path__ + "media/Video 117c.2525e8cf.mp4";